import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Lock } from "@material-ui/icons";
import { Typography } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.95)",
    zIndex: 999999,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    pointerEvents: "all",
    userSelect: "none",
  },
  lockIcon: {
    fontSize: 120,
    marginBottom: theme.spacing(3),
    color: "#f44336",
  },
  title: {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },
  message: {
    fontSize: "1.2rem",
    textAlign: "center",
    maxWidth: "600px",
    padding: theme.spacing(2),
  },
}));

const UserLockOverlay = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [isLocked, setIsLocked] = useState(false);

  // Sincronizar estado com user.isLocked do contexto
  useEffect(() => {    
    if (user?.isLocked !== undefined && user.isLocked !== isLocked) {
      console.log(`🔄 Alterando estado de bloqueio: ${isLocked} → ${user.isLocked}`);
      setIsLocked(user.isLocked);
      
      if (user.isLocked) {
        toast.warning("Sua conta foi bloqueada pelo administrador!", {
          autoClose: false,
        });
      }
    }
  }, [user?.isLocked]);

  // Polling: Verificar status de bloqueio a cada 10 segundos
  useEffect(() => {
    if (!user?.id || user?.profile === "admin") return;

    const checkLockStatus = async () => {
      try {
        const { data } = await api.get("/auth/me");
        
        if (data.user?.isLocked !== undefined && data.user.isLocked !== isLocked) {
          console.log(`🔄 Polling detectou mudança: ${isLocked} → ${data.user.isLocked}`);
          setIsLocked(data.user.isLocked);
        }
      } catch (err) {
        // Silencioso
      }
    };

    const timeout = setTimeout(checkLockStatus, 2000);
    const interval = setInterval(checkLockStatus, 10000);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [user?.id, user?.profile, isLocked]);

  // Não mostrar para admins
  if (user?.profile === "admin") {
    return null;
  }

  // Renderizar overlay se bloqueado
  if (!isLocked) {
    return null;
  }

  console.log("🚨 RENDERIZANDO OVERLAY DE BLOQUEIO");

  return (
    <div className={classes.overlay} style={{ pointerEvents: "all", cursor: "not-allowed" }}>
      <Lock className={classes.lockIcon} />
      <Typography className={classes.title}>
        Acesso Bloqueado
      </Typography>
      <Typography className={classes.message}>
        Seu acesso à plataforma foi temporariamente bloqueado pelo administrador.
        <br />
        Entre em contato com o gestor para mais informações.
      </Typography>
    </div>
  );
};

export default UserLockOverlay;
